import { City } from './city.model';

export class State {
    country: string;
    name: string;
    cities: City[]
}
